import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { LanguageProvider } from './contexts/LanguageContext';
import { StoreProvider } from './contexts/StoreContext';
import { AuthProvider } from './contexts/AuthContext';
import { AppRoutes } from './AppRoutes';
import Preloader from './components/Preloader';

function App() {
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  useEffect(() => {
    // Initial app load preloader
    const timer = setTimeout(() => {
      setIsInitialLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Initial load preloader */}
      <Preloader isLoading={isInitialLoading} />
      
      {/* App content with route transitions */}
      <LanguageProvider>
        <StoreProvider>
          <AuthProvider>
            <Router>
              <AppRoutes />
            </Router>
          </AuthProvider>
        </StoreProvider>
      </LanguageProvider>
      
      {/* Vercel Analytics */}
      <Analytics />
    </>
  );
}

export default App;
